var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('h4',{staticClass:"text-center mb-5"},[_vm._v("Welcome on HTT Interactome")]),_c('gene-search')],1)}
var staticRenderFns = []

export { render, staticRenderFns }